export default __webpack_public_path__ + "static/media/logo-icon.66b29457.png";